<template>
    <section id="product-catalog" class="product-catalog">
        <div class="container">
            <h2 class="title _title">Каталог товаров умного дома</h2>

            <ul class="product-catalog__tabs tags">
                <li
                    class="_item"
                    v-for="(catalogTypeItem, key) in categories"
                    :key="`key_dcdv${key}`"
                >
                    <label>
                        <input
                            v-model="catalogType"
                            type="radio"
                            name="catalogType"
                            :value="catalogTypeItem.id"
                        />
                        <span>{{ catalogTypeItem.name }}</span>
                    </label>
                </li>
            </ul>

            <VueSlickCarousel
                v-bind="settings"
                v-if="products.length"
                class="product-catalog__cards product-catalog-slider"
            >
                <!-- 1 -->
                <div
                    class="_item"
                    v-for="(fabric, key) in products"
                    :key="`key_dcdv${key}`"
                >
                    <div class="_img">
                        <img
                            :src="fabric.media.src"
                            :alt="fabric.name"
                            v-if="windowWidth >= 992"
                        />
                        <img
                            :src="fabric.media.src"
                            :alt="fabric.name"
                            v-else
                        />
                    </div>

                    <div class="smart-home-catalog__content-item-text">
                        <h3>{{ fabric.name }}</h3>

                        <div v-html="fabric.description"></div>
                    </div>
                    <div class="_price">{{ fabric.price }}</div>

                    <button @click="getSmartPageFastBuy" class="btn _primary">
                        Выбрать
                    </button>
                </div>
                <template #prevArrow="arrowOption">
                    <button
                        class="smart-catalog__slick-arrow smart-catalog__slick-arrow_prev"
                    />
                </template>

                <template #nextArrow="arrowOption">
                    <button
                        @submit="loadMore"
                        class="smart-catalog__slick-arrow"
                    />
                </template>
                <!-- /1 -->
            </VueSlickCarousel>

            <div class="product-catalog__mobile">
                <button class="_more" @click="loadMore">Загрузить ещё</button>
                <a class="btn _light _to-top" href="#product-catalog">
                    <span>
                        <img
                            src="/assets/img/automatize/icons/arrow-top.svg"
                            alt=""
                        />
                    </span>
                    <span>Вернуться к категориям</span>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
    name: 'catalogSlider',
    components: { VueSlickCarousel },

    data() {
        return {
            width: 0,
            catalogType: 0,
            products: [],
            responseData: [],
            categories: [],
            activeCategory: '',
            fabric_name: '',
            limit: 40,
            page: 2,
            once: true,
            last_page: null,
            windowWidth: null,
            settings: {
                arrows: true,
                arrowsClass: '.slider.slick-arrow',
                dots: false,
                infinite: false,
                accessibility: true,
                draggable: false,
                zIndex: 1000,
                touchMove: true,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 3040,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: 'unslick',
                    },
                ],
            },
        };
    },

    created() {
        this.width = window.innerWidth;
        window.addEventListener('resize', this.updateWidth);
    },
    mounted() {
        this.getCategories()
            .then((res) => {
                this.categories = res;
            })
            .then(() => {
                if (this.categories && this.categories.length) {
                    this.getCategoryProducts(this.categories[0].id).then(
                        (res) => {
                            this.responseData = res;
                            if (this.width <= 576) {
                                let startPosition = this.products.length;
                                let numberOfItemsToShow = startPosition + 5;
                                let newData = this.responseData.slice(
                                    startPosition,
                                    numberOfItemsToShow
                                );
                                newData.forEach((elem) => {
                                    this.products.push(elem);
                                });
                            } else {
                                this.products = this.responseData;
                            }
                        }
                    );
                }
            });
    },

    destroyed() {
        window.addEventListener('scroll', this.handleResize, { passive: true });
    },

    watch: {
        catalogType(val) {
            // this.page = 1;
            // this.last_page = 1;
            this.responseData = [];
            this.products = [];
            this.getCategoryProducts(val).then((res) => {
                this.responseData = res;
                if (this.width <= 576) {
                    let startPosition = this.products.length;
                    let numberOfItemsToShow = startPosition + 5;
                    let newData = this.responseData.slice(
                        startPosition,
                        numberOfItemsToShow
                    );
                    newData.forEach((elem) => {
                        this.products.push(elem);
                    });
                } else {
                    this.products = this.responseData;
                }
            });
        },
    },

    methods: {
        updateWidth() {
            this.width = window.innerWidth;
        },
        getSmartPageFastBuy() {
            this.$store.commit('setModalStatus', true);
            this.$store.commit('setOverlayStatus', true);
            this.$store.commit('setSmartFastBuyFormStatus', true);
            document.body.classList.add('_no-scroll');
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },

        async getCategories() {
            const response = await this.$http.get(
                '/api/smart-catalog/categories'
            );

            const { body } = response;

            /**
             * @todo add response validation
             */
            if (false) {
                return undefined;
            }

            const { categories } = body.data;

            return categories;
        },

        async getCategoryProducts(category) {
            const response = await this.$http.get(
                `/api/smart-catalog/categories/${category}`
            );
            const { body } = response;
            /**
             * @todo add response validation
             */
            if (false) {
                return undefined;
            }

            const { products } = body.data;
            // this.page = products.current_page++;
            // this.last_page = products.last_page;
            this.activeCategory = category;

            return products;
        },

        loadMore() {
            // if () {
            let startPosition = this.products.length;
            let numberOfItemsToShow = startPosition + 5;
            let newData = this.responseData.slice(
                startPosition,
                numberOfItemsToShow
            );
            newData.forEach((elem) => {
                this.products.push(elem);
            });
            // this.page++;
            // }
        },

        change(items) {
            this.categories = items;
        },
    },
};
</script>
<style>
.smart-home-catalog__content-item-text {
    display: flex;
    flex-direction: column;
    height: 300px;
    overflow: auto;
}
.smart-catalog__slick-arrow {
    position: absolute;
    z-index: 10;
    top: calc(50% - var(--slider-arrow) / 2);
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: var(--c-primary);
    right: -25px;
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    padding: 0;
    transform: translateY(-50%);
    cursor: pointer;
    border: none;
}
.smart-catalog__slick-arrow_prev {
    left: -25px;
}
</style>
